<template>
    <v-row class="fill-height">
        <v-col>
            <v-card>
                <v-card-title>
                    <v-row align="center">

                        <v-col cols="12" lg="2" md="2" sm="12">
                    <v-icon left>mdi-cash-register</v-icon>
                    Caixa
                        </v-col>
<!--                        <v-col cols="12" lg="3" md="3" sm="12">-->
<!--                            <v-text-field-->
<!--                                v-model="cashFlowPagination.search"-->
<!--                                class="mr-3"-->
<!--                                append-icon="mdi-magnify"-->
<!--                                label="Buscar"-->
<!--                                placeholder="Informe o Nome do Serviço"-->
<!--                                single-line-->
<!--                                hide-details-->
<!--                                @keydown.enter="buscar()"-->
<!--                                @click:append="buscar()"-->
<!--                                dense-->
<!--                            ></v-text-field>-->
<!--                        </v-col>-->
                        <v-col cols="12" lg="4" md="5" sm="12">
                            <v-select
                                v-model="cashFlowPagination.account"
                                :items="listAccounts"
                                label="Conta"
                                hide-details
                                item-text="name"
                                :return-object="true"
                                clearable
                                @change="buscar()"
                                dense
                            >
                                <template v-slot:selection="{ item }">
                                    {{ item.accountCategory }} - {{ item.name }}
                                </template>
                                <template v-slot:item="{ item }">
                                    {{ item.accountCategory }} - {{ item.name }}
                                </template>
                            </v-select>
                        </v-col>
                        <v-col cols="12" md="2" sm="12">
                            <v-menu
                                ref="menu1"
                                v-model="menu1"
                                :close-on-content-click="false"
                                transition="scale-transition"
                                offset-y
                                min-width="auto"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        v-model="dateFormattedStart"
                                        label="Data Inícial"
                                        placeholder="Informe uma data para busca."
                                        prepend-inner-icon="mdi-calendar"
                                        v-bind="attrs"
                                        hide-details
                                        @blur="startDate = parseDate(dateFormattedStart)"
                                        @focusout="startDate = parseDate(dateFormattedStart)"
                                        v-on="on"
                                        v-mask="['##/##/####']"
                                        clearable
                                        @input="dateFormattedStart = $event ? $event : ''"
                                        dense
                                    ></v-text-field>
                                </template>
                                <v-date-picker
                                    v-model="startDate"
                                    no-title
                                    @input="menu1 = false"
                                ></v-date-picker>
                            </v-menu>
                        </v-col>
                        <v-col cols="12" md="2" sm="12">
                            <v-menu
                                ref="menu2"
                                v-model="menu2"
                                :close-on-content-click="false"
                                transition="scale-transition"

                                offset-y
                                min-width="auto"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        v-model="dateFormattedEnd"
                                        label="Data Final"
                                        placeholder="Informe uma data para busca."
                                        prepend-inner-icon="mdi-calendar"
                                        v-bind="attrs"
                                        hide-details
                                        @blur="endDate = parseDate(dateFormattedEnd)"
                                        @focusout="endDate = parseDate(dateFormattedEnd)"
                                        v-on="on"
                                        v-mask="['##/##/####']"
                                        clearable
                                        @input="dateFormattedEnd = $event ? $event : ''"
                                        dense
                                    ></v-text-field>
                                </template>
                                <v-date-picker
                                    v-model="endDate"
                                    no-title
                                    @input="menu2 = false"
                                    :min="startDate"
                                ></v-date-picker>
                            </v-menu>
                        </v-col>
                        <v-col cols="12" lg="1" md="2" sm="12">
                            <v-btn
                                class="btn-new"
                                @click="buscar()"
                            >
                                <v-icon >mdi-magnify</v-icon>
                                <span class="d-md-none" >Pesquisar</span>
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col cols="12" lg="12" md="12" sm="12">
                            <v-divider></v-divider>
                        </v-col>
                        <v-spacer></v-spacer>
                        <v-col class="green--text py-1 my-1">
                            <b>Crédito Total:</b> {{cashFlows.credito | money}}
                        </v-col>
                        <v-col class="red--text py-1 my-1">
                           <b>Débito Total:</b> {{cashFlows.debito | money}}
                        </v-col>

                    </v-row>
                </v-card-text>
                <v-alert type="warning" outlined v-show="!cashFlows.items"
                >Nenhum Movimento Encontrado
                </v-alert
                >

                <v-expansion-panels v-if="chartData()" :value="0" accordion hover flat class="rounded-0">
                <v-expansion-panel>
                    <v-expansion-panel-header>Gráfico</v-expansion-panel-header>
                    <v-expansion-panel-content>
                        <app-chart chartType="bar" chartHeight="300" :chartOptions="chartOptions()" :chartData="chartData()"  />
                    </v-expansion-panel-content>
                </v-expansion-panel>
                </v-expansion-panels>

                <v-card-actions class="d-flex justify-end py-3 px-4">
                    <v-btn @click="generateReport('csv')" class="btn-back">
                        CSV <v-icon right>mdi-file-table-outline</v-icon>
                    </v-btn>
                    <v-btn class="btn-back" @click="generateReport('download')">PDF <v-icon right>mdi-file-download-outline</v-icon></v-btn>
                    <v-btn class="btn-back" @click="generateReport('print')">Imprimir <v-icon right>mdi-printer-outline</v-icon></v-btn>
                </v-card-actions>

                <v-data-table
                    id="cashFlows-list"
                    v-model="selected"
                    :headers="headers"
                    :items="cashFlows.items"
                    :options.sync="options"
                    :server-items-length="cashFlows.totalItems"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    item-key="id"
                    class="elevation-1"
                    v-show="cashFlows.items"
                    :footer-props="{
                        'items-per-page-options': [10, 25, 50, 75, 100]
                    }"
                >
                    <template v-slot:item.requestDate="{ item }">
                        {{ item.requestDate | formatDate3 }}
                    </template>
                    <template v-slot:item.description="{ item }">
                        <router-link style="text-decoration: none; color: inherit;" :to="{ name: 'charge', params: { id: item.chargeID } }" v-if="item.chargeID">{{ item.description }}</router-link>
                        <span v-else>{{ item.description }}</span>
                    </template>
                    <template v-slot:item.accountMovementName="{ item }">
                        <span v-if="item.accountMovementName && item.accountMovementName">
                            {{item.accountMovementName}}
                        </span>
                        <span v-else>
                        {{ item.accountMovementName }}
                        {{ item.accountReceiptName }}
                        </span>
                    </template>
                    <template v-slot:item.valueReleased="{ item }">
                        {{ item.valueReleased | money }}
                    </template>
                    <template v-slot:item.valueAnticipation="{ item }">
                        {{ item.valueAnticipation | money }}
                    </template>
                    <template v-slot:item.personName="{ item }">
                        {{item.personName}} {{item.bmName}}
                    </template>
                    <template v-slot:item.value="{ item }">
                        <b class="green--text" v-if="item.movementType == 'C'">{{ item.value | money }}</b>
                    </template>
                    <template v-slot:item.movementType="{ item }">
                        <b class="red--text" v-if="item.movementType == 'D'">{{ item.value | money }}</b>
                    </template>



                    <template v-slot:item.actions="{ item }">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    icon
                                    class="btn-lyndus"
                                    v-bind="attrs"
                                    v-on="on"
                                    :to="{ name: 'charge', params: { id: item.chargeID } }"
                                >
                                    <v-icon>mdi-eye</v-icon>
                                </v-btn>
                            </template>
                            <span>Visualizar</span>
                        </v-tooltip>
                    </template>
                    <!-- <template v-slot:item.actions="{ item }">
                         <v-tooltip bottom>
                             <template v-slot:activator="{ on, attrs }">
                                 <v-btn
                                     icon
                                     class="btn-lyndus"
                                     v-bind="attrs"
                                     v-on="on"
                                     :to="{ name: 'usersEdit', params: { id: item.id } }"
                                 >
                                     <v-icon>mdi-pencil</v-icon>
                                 </v-btn>
                             </template>
                             <span>Editar</span>
                         </v-tooltip>
                     </template>-->
                </v-data-table>
            </v-card>
        </v-col>
    </v-row>

</template>

<script>
import {mask} from "vue-the-mask";
import {mapGetters} from "vuex";
import store from "@/store";

import html2pdf from 'html2pdf.js';
import AppChart from "@/components/AppChart";

import {CHANGE_PROGRESS} from "@/store/mutations/mutations.type";

import {
    ACCOUNTS_LIST_GET, FINANCE_CREATE
} from "@/store/actions/financial.type";

import {SET_CASH_FLOW_PAGINATION} from "@/store/mutations/cash-flow.type";
import {CASH_FLOW_SEARCH} from "@/store/actions/cash-flow.type";

export default {
    name: "financial",
    directives: {mask},
    components: {AppChart},
    async beforeRouteUpdate(to, from, next) {
        // Reset state if user goes from /editor/:id to /editor
        // The component is not recreated so we use to hook to reset the state.
        // await store.commit(CASH_FLOW_RESET_STATE);
        return next();
    },
    async beforeRouteEnter(to, from, next) {
        // await store.commit(CASH_FLOW_RESET_STATE);
        await store.dispatch(ACCOUNTS_LIST_GET);
        
        return next();
    },
    async beforeDestroy() {
        if(!this.$route.path.includes('/cashFlow')){
            localStorage.removeItem('cashFlowOptions')
        }
    },
    data: () => ({
        textRules: [
            (v) => !!v || "Este campo é obrigatório",
            //v => v > 0 || "Esta campo deve ter um valor maior que zero."
        ],
        sortBy: 'dueDate',
        sortDesc: true,
        selected: [],
        options: {},
        headers: [
            {text: "Data", align: "left", value: "competencyDate"},
            {text: "Conta", value: "accountMovementName"},
            {text: "Descrição", value: "description"},
            {text: "Pessoa", value: "personName"},
            {text: "Data Recebimento", value: "dueDate"},
            {text: "Crédito", value: "value"},
            {text: "Débito", value: "movementType"},
            
            // {text: "Usuário", value: "username"},
            // {text: "Visualizar", value: "actions", sortable: false}
        ],
        account: 0,
        startDate: "",
        endDate: "",
        dateFormattedStart: null,
        dateFormattedEnd: null,
        menu1: false,
        menu2: false,
        
        tab: null,
        bankAccountIndex: null,
        localBanks: [],
        search: null,
        balanceRequestValue: 0,
        balanceRequest: {
            value: 0,
            valueReleased: 0,
            valueToReleased: 0,
            valueTotal: 0,
            valueRate: 0,
            bankID: 0
        },

        formIsValid: false,
        optionsMoney: {
            locale: "pt-BR",
            prefix: "R$:",
            length: 9,
            precision: 2
        },
        active: false,
        btnBalanceCheck: true,

        dialogRescueBalance: false,
        dialogBalance: false,
        dialogBankAccount: false,


        dialogBankRemove: false,
        socialEdit: false,
        updateLogo: null,


        social: {
            socialID: 0,
            url: "",
        },

        balance: {
            socialID: 0,
            url: "",
        },
        subtitle: {
            socialID: 0,
            url: "",
        },

        pixRules: [
            v => !!v && !!this.bankAccount.bank && this.bankAccount.agency && this.bankAccount.account || "Este campo é obrigatório"
            //v => v > 0 || "Esta campo deve ter um valor maior que zero."
        ],

    }),

    methods: {
        formatDate(date) {
            if (!date) return null

            const [year, month, day] = date.split('-')
            return `${day}/${month}/${year}`
        },
        parseDate(date) {
            if (!date) return null

            const [day, month, year] = date.split('/')
            return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
        },
        
        rescueRules(v) {
            let n = parseFloat(v.replace(".", "").replace(",", "."))
            if (isNaN(n)) return "Informe um valor válido ";

            if (n < 1) return "O Valor Mínimo é de R$ 1,00";

            if (this.finance.balanceTotal < n) return "O Valor informado é maior que o Saldo Total";

            return true
        },
        bankRulesValid(v) {
            if (!this.bankAccount.chavePIX) {
                return !!v || "Este campo é obrigatório"
            }
            return true
        },
        pixRulesValid(v) {
            if (!this.bankAccount.bank && !this.bankAccount.agency && !this.bankAccount.account) {
                return !!v || "Este campo é obrigatório"
            }
            return true
        },

        removeBankDialog(id, index) {
            this.dialogBankRemove = true;
            this.bankAccount.id = id
            this.bankAccountIndex = index
        },
        dialogRescueBalanceDialog() {

            this.dialogRescueBalance = true;
            for (let i = 0; i < this.bankAccounts.length; i++) {
                if (this.bankAccounts[i].default) {
                    this.balanceRequest.bankID = this.bankAccounts[i].id
                    return
                }
            }

        },
        loadExtract() {
            this.buscar()
        },
        async buscar() {
            const {sortBy, sortDesc, itemsPerPage, page} = this.options

            
            store.commit(SET_CASH_FLOW_PAGINATION, {
                page: page,
                itemsPerPage: itemsPerPage,
                orderBy: sortBy,
                sortDesc: sortDesc[0],
                startDate: this.startDate,
                endDate: this.endDate
            })
            await store.dispatch(CASH_FLOW_SEARCH);
            this.dateFormattedStart = this.cashFlows.startDate
            this.dateFormattedEnd = this.cashFlows.endDate
            
            this.startDate = this.parseDate(this.dateFormattedStart)
            this.endDate = this.parseDate(this.dateFormattedEnd)

        },
        async rescueBalance() {

            this.dialogRescueBalance = false;

            await this.$store
                .dispatch(FINANCE_CREATE, this.balanceRequest)
                .then(response => {
                    this.$store.commit(CHANGE_PROGRESS, false);

                    this.snackbar.snackbar = true;
                    this.snackbar.color = "success";
                    this.snackbar.text = "Salvo com sucesso";

                    this.$refs.formBalanceRescue.reset()
                    this.$router.push({
                        name: "financialView",
                        params: {id: response.data.id}
                    });
                })
                .catch(({response}) => {
                    this.$store.commit(CHANGE_PROGRESS, false);
                    this.snackbar.snackbar = true;
                    this.snackbar.color = "error";
                    this.snackbar.text = "Erro ao Salvar";
                    if (typeof response.data.message !== "undefined") {
                        this.snackbar.text =
                            "Erro ao salvar: " + response.data.message;
                    }
                });


        },
        
        //Dialog Balance - Botão Liberar Saldo

        closeBalance() {
            this.$refs.formBalance.resetValidation();
            this.socialEdit = false;
            this.dialogBalance = false;
            this.social.socialID = null;
            this.social.url = "";
        },


        //Dialog Bank Account - Botão Adicionar (Conta)
        closeBankAccount() {
            this.$refs.formBankAccount.resetValidation();
            this.socialEdit = false;
            this.dialogBankAccount = false;
            this.social.socialID = null;
            this.social.url = "";
        },

        generateReport(type) {
            this.options.page = 1
            this.options.itemsPerPage = this.cashFlows.totalItems
            const element = document.getElementById('cashFlows-list');
            const options = {
            margin:[24, 20, 24, 20],
            filename: 'cashFlows_data.pdf',
            image: { type: 'jpeg', quality: 0.98 },
            html2canvas: { scale: 2 },
            jsPDF: { unit: 'pt', format: 'a4', orientation: 'portrait' },
            compressPDF: true
            };
            setTimeout(() => {
                if(type === 'download'){
                    html2pdf().from(element).set(options).save();
                }else if(type === 'csv'){
                    const data = this.cashFlows.items;
                    const csvContent = this.convertToCSV(data);
                    const blob = new Blob([csvContent], {type: 'text/csv;charset=utf-8'});
                    const url = URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'cashFlows_data.csv');
                    link.click();
                }else{
                    html2pdf().from(element).set(options).toPdf().get('pdf').then(function (pdfObj) {
                        pdfObj.autoPrint();
                        window.open(pdfObj.output('bloburl'), '_blank');
                    });
                }
                this.options.itemsPerPage = 10
            }, 2000);
        },
        convertToCSV(data){
            
            const rewritedArray = data.map(({dueDate, movementDate, movementType, accountMovementName, accountReceiptName, description, personName, value}) => (
                
                {
                    Data: movementDate,
                    Conta: accountMovementName ? accountMovementName : accountReceiptName,
                    Descrição: description,
                    Pessoa: personName,
                    'Data Recebimento': dueDate,
                    Crédito: movementType == 'C' ? `R$ ${value}` : '',
                    Débito: movementType == 'D' ? `R$ ${value}` : '',
                }
            ))
            const headers =  Object.keys(rewritedArray[0]);
            const rows = rewritedArray.map(obj => headers.map(header => obj[header]));
            const headerRow = headers.join(',');
            const csvRows = [headerRow, ...rows.map(row => row.join(','))];
            return csvRows.join('\n');
        },
        chartData(){
            
            const chartDataArray = this.cashFlows.items.map(function (items) {
                return Object({
                    date : items.dueDate,
                    credit : items.movementType == 'C' ? items.value : null,
                    debit : items.movementType == 'D' ? items.value : null,
                })
            })
            const groupByDate = Object.values(chartDataArray.reduce((a, {date, credit, debit}) => {
                a[date] = (a[date] || {date, credit: 0, debit: 0});
                a[date].credit = String(Number(a[date].credit) + Number(credit));
                a[date].debit = String(Number(a[date].debit) + Number(debit));
                return a;
            }, {}));
            
            const creditSum = groupByDate.map(function(items)
            {
                return Number(items.credit)
            })
            const debitSum = groupByDate.map(function(items)
            {
                return Number(Math.abs(items.debit))
            })
            const series = [{
                    name: 'Débito',
                    data: debitSum
                },
                {
                    name: 'Crédito',
                    data: creditSum
                }
            ]
            return series
        },
        chartOptions(){
            const groupByDate = Object.values(this.cashFlows.items.reduce((a, {dueDate, value, movementType}) => {
                a[dueDate] = (a[dueDate] || {dueDate, value: 0, movementType});
                a[dueDate].value = String(Number(a[dueDate].value) + Number(value));
                return a;
            }, {}));
            const chartCategories = groupByDate.map(function(date){
                return date.dueDate
            })
            const options = {
                chart: {
                    height: 350,
                    stacked: true,
                },
                colors: ['#F15B46', '#4CAF50'],
                plotOptions: {
                    bar: {
                        columnWidth: '80%',
                        borderRadius: 4,
                        dataLabels: {
                        position: 'center', 
                        },
                    }
                    },
                    dataLabels: {
                        enabled: true,
                        formatter: function (val) {
                            return "R$ " + val.toFixed(2);
                        },
                        style: {
                            fontSize: '10px',
                            colors: ["#000"]
                        }
                    },
                    yaxis: {
                    labels: {
                        formatter: function (y) {
                        return "R$ " + y.toFixed(2);
                        }
                    }
                    },
                    xaxis: {
                    categories: chartCategories,
                    labels: {
                        rotate: -90
                    }
                }
            
            }
            return options
        }
    },
    created() {
        console.log("->", this.cashFlows.startDate, this.cashFlows.endDate)
        
        this.dateFormattedStart = this.cashFlows.startDate
        this.dateFormattedEnd = this.cashFlows.endDate

        this.startDate = this.parseDate(this.dateFormattedStart)
        this.endDate = this.parseDate(this.dateFormattedEnd)

    },
    mounted() {
        if (localStorage.getItem('cashFlowOptions')){
            this.options = JSON.parse(localStorage.getItem('cashFlowOptions'))
        }
    },
    watch: {
        search(val) {
            val && val !== this.select && this.querySelections(val)
        },

        options: {
            handler(newOptions) {
                this.buscar()
                const parsed = JSON.stringify(newOptions)
                localStorage.setItem('cashFlowOptions', parsed)
            },
            deep: true,
        },
        startDate() {
            this.dateFormattedStart = this.formatDate(this.startDate)
        },
        endDate() {
            this.dateFormattedEnd = this.formatDate(this.endDate)
        },
    },
    computed: {
        ...mapGetters(["snackbar", "cashFlows", "cashFlowPagination", "listAccounts"]),
    }
    ,
}
;
</script>